// prettier-ignore
import { configureStore } from "@reduxjs/toolkit";
import {
  accountBillingDetailReducer,
  accountCategoryReducer,
  accountManagerReducer,
  accountReducer,
  accountSourceReducer,
  accountTypeReducer,
  activityNameReducer,
  activityReducer,
  activityStatusReducer,
  activityTypeReducer,
  addressReducer,
  addressTypeReducer,
  assignmentTypeReducer,
  attachmentReducer,
  billingFrequencyReducer,
  budgetStatusReducer,
  businessNeedStatusReducer,
  campaignCategoryReducer,
  campaignChannelReducer,
  campaignReducer,
  campaignTargetMetricReducer,
  campaignTypeReducer,
  channelStatusReducer,
  closureReasonReducer,
  companySizeReducer,
  competitorAnalysisReducer,
  competitorReducer,
  competitorRoleReducer,
  competitorStatusReducer,
  competitorThreatLevelReducer,
  competitorTypeReducer,
  consentSourceReducer,
  consentStatusReducer,
  contactCommunicationReducer,
  contactDepartmentReducer,
  contactMethodReducer,
  contactPrivacyConsentReducer,
  contactReducer,
  contactRoleReducer,
  contactSourceReducer,
  contactStatusReducer,
  contactTaggingReducer,
  contactTypeReducer,
  contractCategoryReducer,
  contractReducer,
  contractStatusReducer,
  contractTypeReducer,
  crmPriorityReducer,
  crmStatusReducer,
  crmTeamReducer,
  customerAccountStatusReducer,
  customerBusinessDetailsReducer,
  customerCategoryReducer,
  customerCurrencyReducer,
  customerReducer,
  customerTypeReducer,
  dashboardReducer,
  decisionAuthorityReducer,
  disqualificationReasonReducer,
  engagementLevelReducer,
  idealCustomerProfileReducer,
  industyTypeReducer,
  influenceLevelReducer,
  inquiryConversionReducer,
  inquiryDispositionReducer,
  inquiryQualificationReducer,
  inquiryReducer,
  inquirySourceReducer,
  inquiryTaggingReducer,
  inquiryTypeReducer,
  intentLevelReducer,
  jobTitleReducer,
  leadConversionReducer,
  leadQualificationMaturityReducer,
  leadQualificationReducer,
  leadQualificationStatusReducer,
  leadReducer,
  leadSourceReducer,
  leadTaggingReducer,
  leadTypeReducer,
  marketReducer,
  marketSegmentReducer,
  myProjectReducer,
  nurtureReasonReducer,
  opportunityCompetitorAnalysisReducer,
  opportunityConversionReducer,
  opportunityDetailReducer,
  opportunityQualificationReducer,
  opportunityReducer,
  opportunitySourceReducer,
  opportunityStageReducer,
  opportunityTaggingReducer,
  opportunityTypeReducer,
  orderReducer,
  orderTypeReducer,
  paymentTermReducer,
  personTitleReducer,
  preferredLanguageReducer,
  privacyConsentReducer,
  procurementStatusReducer,
  productCategoryReducer,
  productFeaturesReducer,
  productModuleReducer,
  productReducer,
  productTypeReducer,
  productVariantReducer,
  projectUsersReducer,
  prospectContactCommunicationReducer,
  prospectContactEngagementReducer,
  prospectContactReducer,
  prospectConversionReducer,
  prospectInterestReducer,
  prospectQualificationReducer,
  prospectReducer,
  prospectSourceReducer,
  prospectTaggingReducer,
  prospectTypeReducer,
  purchaseTimelineReducer,
  qualificationReadinessReducer,
  relationshipStatusReducer,
  responseStatusReducer,
  salesRegionReducer,
  salesTeamReducer,
  salesTerritoryReducer,
  segmentTypeReducer,
  seniorityLevelReducer,
  servicesReducer,
  sourceReducer,
  statusHistoryReducer,
  subSegmentReducer,
  targetSegmentReducer,
  timelineStatusReducer,
  winLossReasonReducer
} from "@slice";

// ===========================================================================================
export const store = configureStore({
  reducer: {
    customerType: customerTypeReducer,
    customer: customerReducer,
    customerBusinessDetails: customerBusinessDetailsReducer,
    myProject: myProjectReducer,
    customerAccountStatus: customerAccountStatusReducer,
    customerCurrency: customerCurrencyReducer,
    projectUsers: projectUsersReducer,
    accountManager: accountManagerReducer,
    account: accountReducer,
    accountBillingDetail: accountBillingDetailReducer,
    accountSource: accountSourceReducer,
    industyType: industyTypeReducer,
    customerCategory: customerCategoryReducer,
    contactMethod: contactMethodReducer,
    contactType: contactTypeReducer,
    contactRole: contactRoleReducer,
    salesTeam: salesTeamReducer,
    relationshipStatus: relationshipStatusReducer,
    consentSource: consentSourceReducer,
    address: addressReducer,
    contact: contactReducer,
    contactCommunication: contactCommunicationReducer,
    contactSource: contactSourceReducer,
    contactPrivacyConsent: contactPrivacyConsentReducer,
    leadQualificationStatus: leadQualificationStatusReducer,
    inquiryConversion: inquiryConversionReducer,
    inquiryDisposition: inquiryDispositionReducer,
    closureReason: closureReasonReducer,
    consentStatus: consentStatusReducer,
    opportunityStage: opportunityStageReducer,
    inquiryType: inquiryTypeReducer,
    inquiryTagging: inquiryTaggingReducer,
    leadQualification: leadQualificationReducer,
    leadSource: leadSourceReducer,
    leadTagging: leadTaggingReducer,
    opportunityType: opportunityTypeReducer,
    opportunityDetail: opportunityDetailReducer,
    opportunityQualification: opportunityQualificationReducer,
    opportunityCompetitorAnalysis: opportunityCompetitorAnalysisReducer,
    opportunityTagging: opportunityTaggingReducer,
    opportunitySource: opportunitySourceReducer,
    opportunityConversion: opportunityConversionReducer,
    opportunity: opportunityReducer,
    winLossReason: winLossReasonReducer,
    billingFrequency: billingFrequencyReducer,
    prospect: prospectReducer,
    prospectConversion: prospectConversionReducer,
    prospectInterest: prospectInterestReducer,
    prospectQualification: prospectQualificationReducer,
    prospectSource: prospectSourceReducer,
    productCategory: productCategoryReducer,
    productType: productTypeReducer,
    product: productReducer,
    productVariant: productVariantReducer,
    productModule: productModuleReducer,
    contactTagging: contactTaggingReducer,
    disqualificationReason: disqualificationReasonReducer,
    idealCustomerProfile: idealCustomerProfileReducer,
    nurtureReason: nurtureReasonReducer,
    seniorityLevel: seniorityLevelReducer,
    department: contactDepartmentReducer,
    influenceLevel: influenceLevelReducer,
    companySize: companySizeReducer,
    market: marketReducer,
    marketSegment: marketSegmentReducer,
    channelStatus: channelStatusReducer,
    segmentType: segmentTypeReducer,
    competitorAnalysis: competitorAnalysisReducer,
    productFeatures: productFeaturesReducer,
    crmStatus: crmStatusReducer,
    statusHistory: statusHistoryReducer,
    qualificationReadiness: qualificationReadinessReducer,
    leadQualificationMaturity: leadQualificationMaturityReducer,
    activityType: activityTypeReducer,
    activityName: activityNameReducer,
    activity: activityReducer,
    attachment: attachmentReducer,
    campaignCategory: campaignCategoryReducer,
    campaignType: campaignTypeReducer,
    campaign: campaignReducer,
    targetSegment: targetSegmentReducer,
    campaignTargetMetric: campaignTargetMetricReducer,
    campaignChannel: campaignChannelReducer,
    crmTeam: crmTeamReducer,
    personTitle: personTitleReducer,
    purchaseTimeline: purchaseTimelineReducer,
    activityStatus: activityStatusReducer,
    budgetStatus: budgetStatusReducer,
    engagementLevel: engagementLevelReducer,
    services: servicesReducer,
    source: sourceReducer,
    crmPriority: crmPriorityReducer,
    jobTitle: jobTitleReducer,
    decisionAuthority: decisionAuthorityReducer,
    assignmentType: assignmentTypeReducer,
    preferredLanguage: preferredLanguageReducer,
    contactStatus: contactStatusReducer,
    responseStatus: responseStatusReducer,
    prospectType: prospectTypeReducer,
    paymentTerm: paymentTermReducer,
    salesTerritory: salesTerritoryReducer,
    salesRegion: salesRegionReducer,
    prospectContactCommunication: prospectContactCommunicationReducer,
    prospectContactEngagement: prospectContactEngagementReducer,
    prospectContact: prospectContactReducer,
    prospectTagging: prospectTaggingReducer,
    privacyConsent: privacyConsentReducer,
    inquiry: inquiryReducer,
    inquiryQualification: inquiryQualificationReducer,
    addressType: addressTypeReducer,
    procurementStatus: procurementStatusReducer,
    inquirySource: inquirySourceReducer,
    orderType: orderTypeReducer,
    intentLevel: intentLevelReducer,
    subSegment: subSegmentReducer,
    leadConversion: leadConversionReducer,
    leadType: leadTypeReducer,
    lead: leadReducer,
    accountCategory: accountCategoryReducer,
    accountType: accountTypeReducer,
    contractStatus: contractStatusReducer,
    contractCategory: contractCategoryReducer,
    contractType: contractTypeReducer,
    contract: contractReducer,
    order: orderReducer,
    timelineStatus: timelineStatusReducer,
    competitorStatus: competitorStatusReducer,
    competitorThreatLevel: competitorThreatLevelReducer,
    competitorRole: competitorRoleReducer,
    businessNeedStatus: businessNeedStatusReducer,
    competitor: competitorReducer,
    competitorType: competitorTypeReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
